/**
 * Routes pour les Activités (parcours utilisateur)
 * Le CRUD admin des activités est sous /learning/activities (learning.routes)
 */

import { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/app/ProtectedRoute';
import { lazy } from 'react';
import { AttemptGradeViewPage } from '@/pages/Attempt/AttemptGradeViewPage';

const AttemptResultPage = lazy(
  () => import('@/pages/Attempt/AttemptResultPage')
);
const ActivityExercise = lazy(
  () => import('@/pages/Activities/Exercice/ActivityExercise')
);

const RevisionsPage = lazy(() => import('@/pages/Revisions/RevisionsPage'));
const InProgressAttemptsPage = lazy(
  () => import('@/pages/Learning/InProgressAttemptsPage')
);

export const activitiesRoutes: RouteObject[] = [
  {
    path: 'revisions',
    element: (
      <ProtectedRoute>
        <RevisionsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'learning/in-progress',
    element: (
      <ProtectedRoute>
        <InProgressAttemptsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'learning/attempts/:attemptId',
    element: (
      <ProtectedRoute>
        <ActivityExercise />
      </ProtectedRoute>
    ),
  },
  {
    path: 'learning/attempts/:attemptId/view',
    element: (
      <ProtectedRoute>
        <ActivityExercise />
      </ProtectedRoute>
    ),
  },
  {
    path: 'learning/attempts/:attemptId/result',
    element: (
      <ProtectedRoute>
        <AttemptResultPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'learning/attempts/:attemptId/grade',
    element: (
      <ProtectedRoute>
        <AttemptGradeViewPage />
      </ProtectedRoute>
    ),
  },
];
